import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource)

let api = process.env.API_URL
let prefix = '/feed'

export default {
  get: {
    feed () {
      return Vue.http.get(api + prefix + '/')
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/feed.js